export default __webpack_public_path__ + "static/media/DSC09829.d50aebae.JPG";